module.exports = __webpack_public_path__ + "images/emoji/arrow_backward.a745ab5717d06929f6c9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_backward.png
// module id = JesY
// module chunks = 2